import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-xs group hover:[&>path]:stroke-icon-brand hover:text-icon-brand relative flex cursor-pointer items-center gap-2',
    text: 'hidden lg:block',
    icon: 'group-hover:[&>path]:fill-icon-brand'
  }
});
